import axios from 'axios';

const MailService = {
  async sendMail({ documentId, recipient }) {
    const response = await axios.post(`/mail/${documentId}`, {
      recipient,
    });

    return response.data;
  },
};

export default MailService;
